<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <b>Umowa zlecenie nr ...</b>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><b>Zleceniodawcą:</b></p>
<p>
  Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia, XX Wydział Krajowego Rejestru Sądowego pod nr KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, reprezentowaną przez {{ zamawiajacy }}, 
</p>
<p>a</p>
<p>
  <b>Zleceniobiorcą:</b>
  <br/>
  Imię i nazwisko: ...
  <br/>
  Pesel: ...
  <br/>
  Adres: ...
  <br/>
  <br/>
</p>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 1 Przedmiot umowy</b>
</p>
<ol>
  <li>Zleceniodawca oświadcza, że jest organizatorem wypoczynku – obozów tematycznych dla dzieci i młodzieży na terenie Polski, w tym obozów:
    <ol class="special">
      <li
        v-for="(oboz, index) in wypunktowaneObozy()"
        v-bind:key="index"
      >
      ...
      </li>
    </ol>
łącznie zwanych <b>Obozami.</b>
  </li>
  <li>Zleceniodawca powierza, a Zleceniobiorca zobowiązuje się świadczyć usługi w zakresie:
    <ol type="a">
      <li>pełnienie funkcji wychowawcy i sprawowanie całodobowej opieki nad uczestnikami Obozów oraz</li>
      <li>usługi dodatkowe, określone w par. 3 niniejszej Umowy.</li>
    </ol>
  </li>
  <li>Zleceniobiorca oświadcza, że ukończył kurs na wychowawcę wypoczynku, posiada średnie wykształcenie, aktualne badania lekarskie oraz nie figuruje w Krajowym Rejestrze Karnym.</li>
  <li>Zleceniobiorca będzie wykonywał obowiązki wynikające z niniejszej Umowy osobiście i nie może powierzyć ich w całości lub części innym osobom bez pisemnej zgody Zleceniodawcy.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 2 Usługi wychowawczo-opiekuńcze</b>
</p>
<ol>
  <li>Zleceniobiorca rozpocznie wykonywanie usług opiekuńczych w dniu rozpoczęcia Obozu.</li>
  <li>Miejscem świadczenia usług jest miejsce, w którym odbywa się Obóz. Dokładny adres miejsca świadczenia usług przez Zleceniobiorcę wskaże Zleceniodawca najpóźniej na 2 dni robocze przed datą rozpoczęcia Obozu.</li>
  <li>Dokładną godzinę i miejsce rozpoczęcia wykonywania usług przez Zleceniobiorcę Zleceniodawca (<b>data i miejsce zbiórki</b>) wskaże każdorazowo najpóźniej na 2 dni robocze przed datą rozpoczęcia Obozu.</li>
  <li>Świadczenie usług opiekuńczych w ramach każdego z Obozów zakończy się w dacie zakończenia Obozu, po opuszczeniu miejsca Obozu przez wszystkich jego uczestników, a w przypadku gdy Zleceniobiorca będzie towarzyszył uczestnikom Obozu w drodze powrotnej, świadczenie usług opiekuńczych zakończy się po odebraniu wszystkich uczestników Obozu przez ich rodziców lub opiekunów prawnych.</li>
  <li>Szczegółowe warunki wykonywania przez Zleceniobiorcę obowiązków w zakresie usług opiekuńczych, w tym obowiązki i uprawnienia Zleceniobiorcy, określone są w Załączniku nr 1 do niniejszej umowy tj. w dokumencie “Regulamin Kadry (Wychowawca/Instruktor/Fotorelacja/Pomoc Techniczna) Music &amp; More”. </li>
  <li>Zleceniobiorca będzie pełnił funkcję wychowawcy grupy dzieci, która zostanie przydzielona przez Kierownika danego Obozu.</li>
  <li>Zleceniobiorca ponosi pełną odpowiedzialność za uczestników Obozu w czasie trwania Obozu.
  </li>
</ol>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 3 Usługi dodatkowe - zajęcia dydaktyczne</b>
</p>
  <ol><li>Zleceniodawca zleca Zleceniobiorcy, a Zleceniobiorca przyjmuje zlecenia przeprowadzenia w czasie Obozów zajęć dydaktycznych.</li>
  <li>Szczegółowy zakres obowiązków Zleceniobiorcy w zakresie realizacji usługi dodatkowych określa Załącznik nr 1 <b> Regulamin Kadry (Wychowawca/Instruktor/Fotorelacja/Pomoc Techniczna) Music &amp; More - 2023.</b></li>
  <li>Zleceniobiorca przeprowadzi zajęcia dydaktyczne zgodnie z autorskim programem edukacyjnym opracowanym przez Zleceniodawcę. Zleceniodawca przekaże Zleceniobiorcy materiały dydaktyczne niezbędne dla realizacji programu edukacyjnego nie później niż w dniu rozpoczęciu obozu.</li>
  <li>Zleceniodawca udostępni Zleceniobiorcy sprzęt techniczny niezbędny do realizacji usług dodatkowych.</li>
  <li>Zleceniobiorca przyjmuje do wiadomości, że ze sprzętu w czasie Obozu korzystać mogą także inne osoby upoważnione przez Zleceniodawcę.</li>
  <li>Zleceniobiorca zobowiązuje się korzystać z udostępnionego mu sprzętu wyłącznie w celu realizacji usług dodatkowych.</li>
  <li>Zleceniobiorca odpowiedzialny jest za jakość i terminowość prowadzonych zajęć. Obowiązujący w czasie danego Obozu harmonogram zajęć Zleceniobiorca otrzyma najpóźniej w pierwszym dniu Obozu. 
</li>
  <li>Zleceniobiorca akceptuje okoliczność, że harmonogram zajęć może ulegać modyfikacjom. Zleceniobiorca będzie informowany o modyfikacjach harmonogramu z odpowiednim wyprzedzeniem. 
</li>
  <li>Zleceniobiorca zobowiązany jest do bezzwłocznego informowania Kierownika Wypoczynku o każdym przypadku uniemożliwiającym mu realizację zajęć zgodnie z harmonogramem.
</li>
  <li>W przypadku niemożności przeprowadzenia zajęć w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy, zobowiązuje się on do niezwłocznego, nie później niż 2 godziny przed planowanym rozpoczęciem zajęć, powiadomienia Kierownika Wypoczynku o zaistniałym fakcie.</li>
  <li>Zleceniobiorca zobowiązany jest odbyć szkolenie przed rozpoczęciem obozu, w terminie określonym przez zleceniodawcę.</li>
</ol>


<p align="center" style="margin-bottom: 0px;">
  <b>§ 4 Wynagrodzenie</b>
</p>
<ol>
  <li>Za wykonanie obowiązków określonych w niniejszej Umowie Zleceniodawca zapłaci Zleceniobiorcy wynagrodzenie w wysokości :
    <ol class="special">
      <li
        v-for="(cena, index) in wypunktowaneCeny()"
        v-bind:key="index"
      >
      ...
      </li>
    </ol>
  </li>
  <li>W przypadku braku możliwości realizowania przez Zleceniobiorcę przedmiotu umowy zgodnie z umową i harmonogramem, spowodowanej usprawiedliwioną nieobecnością, Zleceniobiorcy przysługuje wynagrodzenie proporcjonalne do przepracowanego czasu. Przez usprawiedliwioną nieobecność rozumie się wyłącznie nieobecność udokumentowaną zwolnieniem lekarskim lub innym dokumentem urzędowym,</li>
  <li>Strony zgodnie oświadczają, że z uwagi na charakter świadczonych usług do umowy niniejszej nie mają zastosowania przepisy o ustawy o minimalnym wynagrodzeniu za pracę (Dz.U.2020.2207).</li>
  <li>Wynagrodzenie będzie płatne na podstawie ewidencji czasu pracy w miesiącu poprzedzającym wypłatę, w terminie z dołu, w cyklu miesięcznym do 15-tego każdego miesiąca po akceptacji wykonania zlecenia przez Zleceniodawcę, przelewem na wskazany numer konta bankowego przez Zleceniobiorcę.  </li>
  <li>Niezależnie od wynagrodzenia, o którym mowa w ust. 1 powyżej, Zleceniodawca zapewnia Zleceniobiorcy na czas trwania Obozów zakwaterowanie oraz całodzienne wyżywienie.  </li>
  <li>W przypadku gdy Zleceniobiorca będzie realizował usługi opiekuńcze wobec uczestników Obozu w czasie drogi na miejsce Obozu lub w czasie drogi powrotnej, Zleceniodawca zapewnia Zleceniobiorcy dojazd na miejsce Obozu oraz powrót  po zakończeniu Obozu.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 5 Obowiązki Zleceniobiorcy</b>
</p>
  <ol>
    <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością. 
</li>
<li>Zleceniobiorca oświadcza, że zna przepisy i zasady bezpieczeństwa i higieny pracy i zobowiązuje się do ich przestrzegania, a w szczególności do:
</li>
<ol type="a">
  <li>wykonywania zlecenia w sposób zgodny z przepisami i zasadami bezpieczeństwa i higieny pracy;</li>
  <li>dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;</li>
  <li>stosowania występujących w miejscu wykonywania zlecenia dostępnych środków ochrony zbiorowej, a także używania własnych środków ochrony indywidualnej (rękawiczki jednorazowe, osłona ust i nosa, kombinezon), odzieży roboczej, o ile charakter wykonywanej pracy tego wymaga;</li>
  <li>niezwłocznego zawiadomienia Kierownika Wypoczynku lub Kierownika Ośrodka o zauważonym wypadku albo zagrożeniu życia lub zdrowia ludzkiego oraz ostrzeżenia współpracowników i innych osób znajdujących się w rejonie zagrożenia o grożącym im niebezpieczeństwie;</li>
  <li>współdziałania ze Zleceniodawcą w czasie ewakuacji, w sytuacji pożaru  oraz w przypadku konieczności udzielenia pomocy ofiarom wypadków;</li>
  <li>prowadzenia dokumentacji pracy wychowawczej tj. dziennika zajęć, notatek służbowych;</li>
  <li>terminowego wykonywania wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;</li>
  <li>realizowania celów dydaktyczno-wychowawczych poprzez:
<ul>
  <li>motywowanie uczestników i uczestniczek kolonii do samodzielnej pracy i przezwyciężania trudności;</li>
    <li>kształcenie umiejętności niezbędnych do dalszej nauki;</li>
    <li>kształcenie postawy badawczej i naukę logicznego myślenia;</li>
    <li>rozwijanie umiejętności współdziałania w grupie;</li>
    <li>kształcenie postawy szacunku do ludzi i przyrody;</li>
    <li>przeciwdziałanie dyskryminacji ze względu na płeć, wiek, niepełnosprawność, rasę lub pochodzenie etniczne, wyznanie;</li>
    <li>umożliwienie samopoznania w następujących obszarach: wolność osobista a przewidywanie konsekwencji własnych zachowań, odpowiedzialności i obowiązków; potrzeby własne i drugiego człowieka, godność własna i innych; akceptacja indywidualności własnej i drugiego człowieka; dociekliwość intelektualna, niezależność myślenia i twórcze rozwiązywanie problemów; wrażliwość, empatia, kultura osobista, moralność.</li>
</ul>
</li>
</ol> 
<li>Zleceniobiorca zobowiązany jest do rzetelnego wykonywania powierzonych zadań zgodnie z wytycznymi Zleceniodawcy oraz Kierownika Wypoczynku.</li>
<li>Zleceniobiorca ponosi pełną odpowiedzialność za szkody wyrządzone przez swoje działania lub zaniechania podczas wykonywania przedmiotu umowy.
</li>
<li>Zleceniobiorca zobowiązany jest do bezzwłocznego informowania Zleceniodawcy o każdym przypadku uniemożliwiającym mu realizację obowiązków wynikających z niniejszej Umowy.</li>
<li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (tj. Dz.U. 2018 poz. 1000 z późn. zm.) oraz rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 (ogólnego rozporządzenia o ochronie danych, zwanego RODO).
</li>
<li>W przypadku sytuacji losowych wynikających z przyczyn spowodowanych tzw. siłą wyższą, 
np. choroba członka kadry, zalecenia Kuratorium, niespodziewana sytuacja rodzinna (gdy wyznaczenie innego zastępstwa nie byłoby możliwe) w trakcie trwania obozu, Zleceniobiorca, pod warunkiem posiadania odpowiednich uprawnień i dokumentów, może w porozumieniu ze Zleceniodawcą objąć tymczasowo dodatkową funkcję określoną w Załączniku nr 1 Regulamin kadry (Wychowawca/Instruktor/Fotorelacja/Pomoc Techniczna) Music &amp; More.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 6 Odpowiedzialność Zleceniobiorcy</b>
</p>
<ol>
  <li>Zleceniobiorca odpowiada za szkody poniesione przez Zleceniodawcę w związku z nienależytym wykonaniem lub niewykonaniem niniejszej Umowy.</li>
  <li>Zleceniobiorca odpowiada za powierzony mu sprzęt kolonijny.</li>
  <li>W przypadku, gdyby z przyczyn niezależnych od Zleceniobiorcy nie mógł on świadczyć Usług określonych w niniejszej Umowie, zobowiązany jest on niezwłocznie zgłosić tę okoliczność   Zleceniodawcy. W czasie trwania Obozu Zleceniobiorca zgłasza wszelkie okoliczności wpływające na możliwości i terminowość realizacji przez niego usług Kierownikowi Wypoczynku.</li>
  <li>W przypadku nieuzasadnionego nie stawienia się przez Zleceniobiorcę na miejsce zbiórki, o którym mowa w par. 2 ust. 3 niniejszej Umowy lub niezrealizowania zapisów Umowy, Zleceniodawca może naliczyć Zleceniobiorcy karę umowną w wysokości 1.000 zł (słownie: tysiąc złotych). W przypadku jeśli szkoda Zleceniodawcy przewyższa wysokość kary umownej, uprawniony jest on do dochodzenia odszkodowania uzupełniającego na zasadach ogólnych prawa cywilnego.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 7 Klauzula poufności</b>
</p>

<ol>
  <li>Strony, w związku z zawarciem niniejszej umowy zobowiązane są zapewnić należytą ochronę informacji poufnych przekazanych sobie dla potrzeb realizacji niniejszej umowy, w szczególności poprzez odebranie od podmiotów trzecich stosownych oświadczeń woli.</li>
    <li>Za poufne Strony uznają w szczególności informacje dotyczące kwestii:
    <ul>
      <li>finansowych;</li>
      <li>technicznych;</li>
      <li>handlowych; </li>
      <li>know – how;</li>
      <li>koncepcji; </li>
      <li>strategii; </li>
      <li>organizacji;</li>
    </ul>
    </li>
  <li>Za poufne Strony nie uznają w szczególności informacji, które:
<ul>
      <li>w dacie ich ujawnienia stanowią informacje dostępne publicznie;</li>
      <li>są już w dacie podpisania niniejszej umowy znane Stronom i wiedza ta została nabyta zgodnie z prawem, w sposób niezwiązany z realizacją przedmiotu niniejszej umowy;</li>
      <li>zostały po zawarciu niniejszej umowy pozyskane przez Stronę od podmiotów trzecich, które z kolei nie pozyskały takiej informacji bezpośrednio lub pośrednio od drugiej Strony i nie naruszyły w inny sposób jakiegokolwiek zobowiązania poufności. </li>
    </ul>
</li>
  <li>W przypadku gdy Strona, zgodnie z ogólnie obowiązującymi przepisami prawa, w szczególności na wezwanie organów działających w granicach swoich uprawnień ujawni informacje poufne przekazane jej przez drugą Stronę w ramach realizacji niniejszej umowy, ograniczenia wynikające z niniejszego paragrafu nie znajdą zastosowania i działanie takie nie będzie rodziło po stronie Strony ujawniającej informacje żadnej odpowiedzialności.</li>
  <li>Strony zobowiązują się chronić opisane w niniejszym paragrafie informacje poufne także w okresie 36 (trzydziestu sześciu) miesięcy po rozwiązaniu niniejszej umowy.</li>
  <li>W przypadku naruszenia zobowiązań wynikających z niniejszego paragrafu Strona naruszająca zapłaci na żądanie drugiej Strony karę umowną w kwocie stanowiącej równowartość dziesięciokrotności wynagrodzenia wskazanego w niniejszej umowie.</li>
  <li>Zastrzeżenie wyżej wymienionej kary umownej nie wyklucza dochodzenia odszkodowania przenoszącego w/w kary umownej.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 8 Zgoda na wykorzystanie wizerunku</b>
  </p>
<ol>
<li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku utrwalonego w formie zdjęć oraz filmów wideo na następujących nośnikach lub mediach:</li>
<ol type="a">
  <li>na panelu będącym częścią strony Zleceniodawcy, w którym prezentowane będą relacje fotograficzne i filmowe z obozów;</li>
  <li>na nośnikach trwałych typu płyta CD lub pendrive, które zawierały będą relacje z obozów;</li>
  <li>na stronie www Zleceniodawcy;</li>
  <li>na stronach w social media Zleceniodawcy (np. Facebook, Instagram, Twitter).</li>
</ol>
<li>Wizerunek może być wykorzystywany przez Zleceniodawcę w celach informacyjnych i promocyjnych związanych z organizacją wypoczynku.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 9 Rozwiązanie Umowy</b>
</p>
<ol>
  <li>Niniejsza umowa została zawarta na czas określony – na czas trwania Obozów, określony w par. 1.</li>
  <li>Z uwagi na charakter świadczonych usług Strony ograniczają możliwość rozwiązania niniejszej umowy do ważnych przyczyn, a w szczególności:</li>
  <ol>
    <li>Zleceniodawca jest uprawniony do rozwiązania niniejszej Umowy bez zachowania okresu wypowiedzenia w przypadku, gdy:
        <ul>
            <li>Zleceniobiorca bez uzasadnionej przyczyny nie stawi się na miejscu zbiórki;</li>
            <li>Zleceniobiorca bez uzasadnionej przyczyny przestanie świadczyć umówione usługi;</li>
            <li>Zleceniobiorca w sposób uporczywy lub rażący będzie naruszał obowiązki określone w niniejszej Umowie lub załączniku do niej, w tym w zakresie terminowego przeprowadzania zajęć dydaktycznych.</li>
        </ul>
    </li>
    <li>Zleceniobiorca jest uprawniony do rozwiązania niniejszej Umowy bez zachowania okresu wypowiedzenia w przypadku, gdy:
    <ul>
      <li>Zleceniodawca będzie pozostawał w zwłoce z zapłatą wynagrodzenia o co najmniej 10 dni;</li>
    <li>Zleceniodawca w sposób uporczywy lub rażący będzie naruszał swoje obowiązki określone w niniejszej Umowie.</li>
    </ul>
    </li>
  </ol>
  <li>Uwzględniając obowiązujący stan epidemii Strony zgodnie oświadczają, że w przypadku gdyby na skutek wydania aktów prawnych lub decyzji organów administracji organizacja Obozu nie była możliwa, niniejsza Umowa rozwiązuje się, a Zleceniobiorca nie będzie miał wobec Zleceniodawcy żadnych roszczeń finansowych.</li>
  <li>Zleceniodawca może ponadto dochodzić odszkodowania od Zleceniobiorcy z tytułu szkód poniesionych w wyniku zaistnienia sytuacji określonych w par. 9 pkt 2 ppkt 1  do równowartości zaistniałej szkody. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości stawienia się na miejsce zbiórki.</li>
</ol>
<br>


<p align="center" style="margin-bottom: 0px;">
  <b>§ 10 Doręczenia i korespondencja </b>
</p>
<ol>
  <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron,  uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
  <li>Adresy poczty elektronicznej podane są w oznaczeniu stron.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
  <b>§ 11 Postanowienia końcowe</b>
</p>
  <ol>
    <li>Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 (czternastu) dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.</li>
    <li>Umowa niniejsza rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
    <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
    <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
    <li>Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.</li>
    <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
    <li>Umowa niniejsza została sporządzona w 2 (dwóch) jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</li>
  </ol>
<br>


<div class="cointainer" style="margin-top: 30px;">
    <div class="left-cointainer">
        <span style="margin-left: 0%;">...</span><br>
        <span style="margin-left: 0%;"><b>Podpis Zleceniodawcy</b></span>
    </div>
    <div class="right-cointainer">
        ...<br>
        <span style="margin-left: 0%;"><b>Podpis Zleceniobiorcy</b></span>
    </div>
</div>
<br><br>

  <div style="margin-top:5px;page-break-before: always;">
  <p align="center" class="subheading"><b>Oświadczenie Zleceniobiorcy</b></p>

  <table style="border: 1px solid; text-align: left; font-size: 12px;">
  <tbody>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
  <p class="cell-in-first-table"><span><b>DANE OSOBOWE</b></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><b>DO WYPEŁNIENIA</b></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Data</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer PESEL</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer telefonu</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres e-mail</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres zamieszkania</span><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Adres korespondencyjny</span><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Urząd Skarbowy (zgodny z adresem zamieszkania)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><b>OŚWIADCZAM, ŻE:</b></span></p>
  </td>
  <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
  <p class="cell-in-first-table"><span><b>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</b></span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia<br>(jeśli wpisano "TAK", proszę pominąć pkt. 5,6,7)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>
  
  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>5. Umowa cywilno-prawna z Tutore Poland Sp. z o.o.<br>jest moim jedynym tytułem do ubezpieczenia</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>6. Wnoszę o dobrowolne ubezpieczenie chorobowe<br>(tylko w przypadku objęcia ubezpieczeniem emerytalnym i rentowym)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7. Jestem zatrudniony/a na umowę o pracę/umowę zlecenie:<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.1. Nazwa i adres pracodawcy/zleceniodawcy:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>7.2. Wynagrodzenie z tytułu umowy o pracę jest
wyższe bądź równe krajowej płacy minimalnej:</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>8. Podlegam ubezpieczeniu społecznemu z innego tytułu niż umowa o pracę
i/lub umowa zlecenie z Tutore Poland Sp. z o.o. (jeśli wpisano "TAK", proszę określić tytuł ubezpieczenia)</span></p>
  </td>
  <td style="border: 1px solid;">
  <p class="cell-in-first-table"><span>...</span></p>
  </td>
  </tr>

  <tr>
  <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
  <p class="cell-in-first-table"><span><b>
  Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
  <br/>
  Zobowiązuję się do poinformowania Pracodawcy w przypadku zmiany ww. danych w terminie 7 dni od daty zaistnienia zmiany. Wyrażam zgodę na podanie Administratorowi danych osobowych mojego numeru telefonu, adresu e-mail i adresu do korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki rocznych deklaracji rozliczeniowych.
  <br/>
  </b></span></p>
  </td>
  </tr>

  </tbody>
  </table>
  </div>

  <div style="margin-top:40px; page-break-before: always;">
<p align="center" class="subheading"><b>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</b></p>
<ol>
    <li>
      Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel.  535 933 870 info@tutore.eu.
    </li>
      <li>
        Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i  Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w  związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.
      </li>
    <li>
        Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.
    </li>
    <li>
      Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
      <ol type="a">
        <li>zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,</li>
        <li>wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,</li>
        <li>potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,</li>
        <li>realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
        <li>realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
        <li>realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,</li>
        <li>bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,</li>
        <li>tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
        <li>dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.</li>
      </ol>
    </li>
    <li>
      Odbiorcami Pani/Pana danych osobowych będą:
      <ul>
        <li>organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;</li>
        <li>zakłady opieki zdrowotnej w celach związanych z medycyną pracy;</li>
        <li>podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,</li>
        <li>biura księgowe:</li>
        <li>banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;</li>
        <li>kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy;</li>
        <li>współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,</li>
        <li>podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.</li>
        <li>instytucje ubezpieczeniowe</li>
        <li>organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)</li>
        <li>podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)</li>
      </ul>
    </li>
    <li>
      Ma Pani/Pan prawo do:
      <ol type="a">
        <li><b>dostępu do danych</b> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);</li>
        <li><b>otrzymania kopii danych</b> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);</li>
        <li><b>sprostowania</b> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);</li>
        <li><b>usunięcia danych</b> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);</li>
        <li><b>ograniczenia przetwarzania</b> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
          <ol type="i">
            <li>kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,</li>
            <li>przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,</li>
            <li>Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;</li>
            <li>wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;</li>
          </ol>
        </li>
        <li><b>przenoszenia danych</b> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);</li>
        <li><b>sprzeciwu</b> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);</li>
        <li><b>prawo wniesienia skargi do organu nadzorczego</b> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
          <ul>
            <li>pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,</li>
            <li>elektronicznie za pośrednictwem platformy ePUAP.</li>
          </ul>
        </li>
      </ol>
    </li>
    <li>W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.</li>
    <li>Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.</li>
  </ol>

    <div style="page-break-before: always;">
  <div class="container">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><b>OŚWIADCZENIE ZLECENIOBIORCY</b></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>zapoznałem/am się z Informacją o przetwarzaniu moich danych osobowych i przyjmuję ją do wiadomości,</li>
          <li>treść Informacji jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
          </ol>
          </li>
          </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
        </div>
      </td>
    </tr>
  </table>
  </div>
  </div>

<div style="page-break-before: always;">
<p align="center" class="subheading" style="margin-bottom: 0px;">
  <b>
    Upoważnienie<br>
    do przetwarzania danych osobowych w zbiorze w wersji<br>
    papierowej i elektronicznej
  </b>
</p>
<p>&nbsp;</p>
<p>
    Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p>z dniem rozpoczęcia turnusu</p>
<p>upoważniam Pana/Panią ... – Zleceniobiorcę Tutore Poland Sp. z o.o.</p>
<p>do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:</p>
<ol type="a">
  <li>
    w wersji papierowej:
    <ul>
      <li>zbiór danych osobowych Uczestników obozów w postaci kart kwalifikacyjnych – imię i nazwisko, wiek, adres zamieszkania, wzrost, waga, stan zdrowia, szczepienia, przyjmowane leki, dieta.</li>
    </ul>
  </li>
  <li>
    w wersji elektronicznej:
    <ul>
      <li>zbiór danych osobowych Uczestników: dzieci korzystających z obozów oferowanych przez Tutore Poland Sp. z o.o. – imię i nazwisko, wiek, adres zamieszkania, stan zdrowia, szczepienia, dieta,</li>
      <li>zbiór danych osobowych kadry wychowawców obozów organizowanych przez Tutore Poland Sp. z o.o. – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail,</li>
    </ul>
  </li>
</ol>
<p>w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.</p>
<p>Niniejsze  upoważnienie  nie  upoważnia  do  udzielania  dalszych  upoważnień  i  wygasa  z  dniem ustania stosunku pracy lub umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.</p>
<p>Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady  (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych  oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o. wewnętrznymi regulacjami w sprawie ochrony danych osobowych.</p>
<p>Naruszenie ww. obowiązków  może skutkować  poniesieniem  odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.</p>
</div>
</div>

<div style="page-break-before: always;">
<table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tr>
    <td id="oswiadczenie">
      <p align="center" class="subheading"><b>OŚWIADCZENIE ZLECENIOBIORCY</b></p>
      <ol>
    <li>Ja niżej podpisany/a oświadczam, iż:
      <ol type="a">
        <li>zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,</li>
        <li>treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,</li>
        <li>zobowiązuję się do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,</li>
        <li>zobowiązuję się do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,</li>
        <li>zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.</li>
      </ol>
      </li>
      </ol>
      <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
      </div>
    </td>
  </tr>
</table>
</div>

<div style="page-break-before: always;">
  <p style="text-align: center;">{{ aktualnaData() }} - ...</p>
  <p class="subheading" style="text-align: center;"><b>... - osoba reprezentująca spółkę</b></p>
  <p style="text-align: center;"><b>w imieniu Administratora</b></p>
  <p>Niniejsze upoważnienie uchylone zostało w dniu ... - data zakończenia ostatniego turnusu</p>
  <div style="font-size: 10px;">
  <p class="subheading" style="text-align: center;"><b>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH OBEJMUJĄCYCH WIZERUNEK ZLECENIOBIORCÓW</b></p>
  <p>Tutore Poland Sp. z o.o., nazywana dalej Spółką, zamierza wykorzystywać wizerunek zleceniobiorców w celach marketingowych obejmujących: umieszczenie na stronach internetowych należących do marek Spółki, zamieszczenie w materiałach promocyjnych Spółki (np. ulotki, katalogi), zamieszczenie w materiałach informacyjnych Spółki, umieszczenie na łamach firmowych mediów społecznościowych (m.in. FB, Instagram) oraz w ramach prowadzonych kanałów video (Youtube). Na podstawie art. 6 ust. 1 lit. a RODO, przetwarzanie przez Spółkę wizerunku zleceniobiorców dla opisanych celów marketingowych wymaga wyrażenia zgody przez osoby fizyczne, których dane są przetwarzane.</p>
  <p class="subheading" style="text-align: center;"><b>KLAUZULA INFORMACYJNA Tutore Poland Sp. z o.o.</b></p>
  <p>Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, poniżej zamieszczamy informacje dotyczące przetwarzania danych osobowych w postaci wizerunku zleceniobiorców przez Tutore Poland Sp. z o.o., dalej ADO:</p>
  <ol>
    <li>Administratorem Danych Osobowych jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel.  500 965 135 info@tutore.eu</li>
    <li>ADO przetwarza dane osobowe w postaci wizerunku w celach marketingowych opisanych w Informacji o przetwarzaniu danych osobowych obejmujących wizerunek zleceniobiorców na podstawie wyrażonej zgody (Art. 6 ust. 1 lit. a RODO).</li>
    <li>Odbiorcami danych osobowych mogą być podmioty świadczące usługi informatyczne i wsparcia www oraz przygotowujące kampanie i materiały promocyjne (agencje reklamowe, agencje interaktywne), podmioty prasowe.</li>
    <li>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</li>
    <li>Dane osobowe przechowywane będą przez okres niezbędny dla realizacji celów określonych w pkt 2 lub do czasu cofnięcia zgody przez zleceniobiorcę.</li>
    <li>Osoba której dane są przetwarzane ma prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do ograniczenia przetwarzania, prawo do bycia zapomnianym, prawo do sprzeciwu, prawo do przenoszenia danych, prawo do cofnięcia udzielonej zgody w każdym czasie, prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</li>
    <li>Podanie danych osobowych jest całkowicie dobrowolne.</li>
    <li>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</li>
  </ol>
  </div>
</div>

<div style="page-break-before: always;">
<table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
  <tr>
    <td id="oswiadczenie">
      <p align="center" class="subheading"><b>OŚWIADCZENIE ZLECENIOBIORCY ZE ZGODĄ NA PRZETWARZANIE DANYCH OSOBOWYCH</b></p>
      <ol>
    <li>Ja niżej podpisany/a ... oświadczam, iż:
      <ol type="a">
        <li>zapoznałem/am się z Informacją o przetwarzaniu danych osobowych obejmujących wizerunek zleceniobiorców oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,</li>
        <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną z Tutore Poland Sp. z o.o., w sposób wyczerpujący,</li>
      </ol>
    </li>
        <li>W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w zakresie mojego wizerunku dla opisanych wyżej celów marketingowych.</li>
        <li>Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych przed złożeniem oświadczenia o cofnięciu zgody. </li>
        <li>W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o., dla celów marketingowych opisanych powyżej.</li>
      </ol>
      <div class="right-cointainer" style="float: right; margin-top: 20px;">
        <span style="font-size: 14px;">...</span>
        <br>
        <span>czytelny podpis Zleceniobiorcy</span>
      </div>
    </td>
  </tr>
</table>
</div>

  
<div style="page-break-before: always;">
  <p class="subheading" style="text-align: center;"><b>Oświadczenie w sprawie ochrony zdrowia i życia dzieci oraz młodzieży na obozach
   Music &amp; More</b></p>
  <p>W poczuciu pełnej osobistej odpowiedzialności przed własnym sumieniem, rodzicami i społeczeństwem, za  bezpieczeństwo, zdrowie i życie powierzonych mej opiece dzieci oraz młodzieży na obozie/ obozach Music &amp; More, organizowanym/organizowanych w okresie trwania obozu.</p>
  <p>Oświadczam, co następuje:</p> 

  <ol>
    <li>Z należytą uwagą i zrozumieniem zapoznałem/am się ze wszystkimi dokumentami i przepisami dotyczącymi bezpieczeństwa, zdrowia i życia dzieci oraz młodzieży na obozie Music &amp; More.</li>
    <li>Z należytą uwagą i zrozumieniem zapoznałem/am się z zakresem obowiązków, odpowiedzialności i  uprawnień  oraz wytycznymi i standardami dedykowanymi  dla powierzonej mi funkcji.</li>
    <li>Zobowiązuję się do rzetelnego przestrzegania i stosowania zawartych w dokumentach, przepisach,  wytycznych i standardach wskazówek, zaleceń i zarządzeń.</li>
    <li>Zobowiązuje się do nie ujawniania poufnych informacji osobistych, z którymi mogę się zetknąć w czasie  pełnienia obowiązków na turnusie.</li>
  </ol>
  
  <div class="right-cointainer" style="float: right; margin-top: 20px;">
    <span style="font-size: 14px;">...</span>
    <br>
    <span>czytelny podpis Zleceniobiorcy</span>
  </div>
</div>

<div style="margin-top: 100px;">
  <p class="subheading" style="text-align: center;"><b>Oświadczenie w sprawie odpowiedzialności materialnej</b></p>
  <p>Z tytułu przyjętych na siebie obowiązków, ponoszę pełną odpowiedzialności materialną za sprzęt i
  majątek z którego korzystać będę w okresie wykonywanych zleconych czynności. Zobowiązuję się do
  pokrycia wszystkich strat powstałych na skutek mojego niedopatrzenia lub wadliwie prowadzonej
  przeze mnie eksploatacji powierzonego mi sprzętu. Zgadzam się na pokrycie (przez potrącenie mi
  należnych mi poborów za pracę podczas obozów) równowartości udokumentowanych strat
  wynikłych z mojej winy. Podstawa prawna: art. 415,471 K.C.
  </p>

  <div class="right-cointainer" style="float: right; margin-top: 20px;">
    <span style="font-size: 14px;">...</span>
    <br>
    <span>czytelny podpis Zleceniobiorcy</span>
  </div>
</div>

  </td></tr>
  </tbody></table>

  </v-container>
</template>

<script>
export default {
  name: 'WzorUmowaWychowawcaZimowiska2023',
  props: {
  },
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrumowy: '',
      datapocz: '',
      datakon: '',
      kwota: '',
      wypo: '',
      slownie: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      nazwa1: '',
	    nazwa2: '',
	    nazwa3: '',
      jedyneUbezpieczenie: '',
      tytulUbezpieczenieUmowaPraca: '',
      ubezpieczenie: '',
      adresPracodawca: '',
      placaMinimalna: '',
      ubezpieczenieSpoleczne: '',
      ubezpieczenieTytul: ''
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      tab = this.nrumowy.split('/')
      this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/Nau`
      return this.shortUmowa
    },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    dataOstatniegoTurnusu() {
      const obozy = this.nazwa1;
      const lastIndex = obozy.lastIndexOf('2022');
      const result = obozy.substr(lastIndex - 6, 10);
      return result;
    },
    aktualnaData() {
      const today = new Date();
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = today.getDate()+'-'+month+'-'+today.getFullYear()
      return todayDate
    },
    wypunktowaneObozy() {
      let obozy = this.nazwa1.split('*');
      obozy = obozy.filter(oboz => oboz.length !== 0);
      return obozy
    },
    wypunktowaneCeny() {
      let cenyObozów = this.koszt1.split('*');
      cenyObozów = cenyObozów.filter(cena => cena.length !== 0);
      return cenyObozów
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
}

ol.special {
    counter-reset: list;
}

ol.special > li {
    list-style: none;
}

ol.special > li:before {
    content: counter(list) ") ";
    counter-increment: list;
}
</style>



// WEBPACK FOOTER //
// src/components/WzorUmowaWychowawcaZimowiska2023.vue